import { useEffect, useState } from "react";

export const SnowEffect = () => {
  const [snowflakes, setSnowflakes] = useState([]);

  useEffect(() => {
    // Create 50 snowflakes with better visibility
    const flakes = Array.from({ length: 50 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 5,
      duration: 8 + Math.random() * 8, // Faster animation (8-16s)
      size: Math.random() * 10 + 5, // Larger snowflakes (5-15px) for better visibility
      drift: (Math.random() - 0.5) * 60, // More horizontal drift
    }));
    setSnowflakes(flakes);
  }, []);

  if (snowflakes.length === 0) {
    return null;
  }

  return (
    <>
      <div 
        className="fixed inset-0 pointer-events-none overflow-hidden" 
        style={{ zIndex: 0 }}
      >
        {snowflakes.map((flake) => (
          <div
            key={flake.id}
            className="absolute rounded-full"
            style={{
              left: `${flake.left}%`,
              width: `${flake.size}px`,
              height: `${flake.size}px`,
              backgroundColor: '#FFFFFF',
              animation: `snowfall-${flake.id} ${flake.duration}s linear infinite`,
              animationDelay: `${flake.delay}s`,
              opacity: 1,
              boxShadow: '0 0 2px rgba(255, 255, 255, 1)',
            }}
          />
        ))}
      </div>
      <style dangerouslySetInnerHTML={{
        __html: `
          ${snowflakes.map((flake) => `
            @keyframes snowfall-${flake.id} {
              0% {
                transform: translateY(-10vh) translateX(0px) rotate(0deg);
                opacity: 0.9;
              }
              50% {
                transform: translateY(50vh) translateX(${flake.drift}px) rotate(180deg);
                opacity: 0.7;
              }
              100% {
                transform: translateY(110vh) translateX(${flake.drift * 2}px) rotate(360deg);
                opacity: 0;
              }
            }
          `).join('')}
        `
      }} />
    </>
  );
};

